import {
  Component,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { reasonOfDecline } from "./reason-of-decline.const";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Dialog } from "primeng/dialog";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-quote-decline-form",
  templateUrl: "./quote-decline-form.component.html",
  styleUrls: ["./quote-decline-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, Bind, Dialog, Select, FormsModule],
})
export class QuoteDeclineFormComponent implements OnInit {
  readonly closeView = output();
  readonly declineQuote = output<string>();

  public reasonOfDecline: string;
  public reasonOfDeclineList: SelectItem[] = [];

  constructor() {}

  public ngOnInit() {
    this.buildReasonOfDeclineList();
  }

  public close() {
    this.closeView.emit();
  }

  public decline() {
    this.declineQuote.emit(this.reasonOfDecline);
  }

  private buildReasonOfDeclineList() {
    Object.keys(reasonOfDecline).map((key) => {
      this.reasonOfDeclineList.push({
        label: reasonOfDecline[key],
        value: key,
      });
    });

    this.reasonOfDeclineList.sort((a, b) => a.label.localeCompare(b.label));

    this.reasonOfDecline = this.reasonOfDeclineList[0].value;
  }
}
